export const VIDEO_PLAYER = {
  SLIDER_STEP: 0.001,
  MAX_VALUE_DEFAULT: 100,
  VALUE_MULTIPLIER: 100,
};
